"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/stream/v1/admin_common.proto (package spwn.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLiveChannel_InputAttachment = exports.MediaLiveChannel = exports.HoldingChannel_StreamingKeyInfo = exports.HoldingChannel = exports.Endpoint = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.stream.v1.Endpoint
 */
class Endpoint extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: int32 start_over_window_seconds = 2;
         */
        this.startOverWindowSeconds = 0;
        /**
         * @generated from field: string url = 3;
         */
        this.url = "";
        /**
         * @generated from field: map<string, string> cookie = 4;
         */
        this.cookie = {};
        /**
         * @generated from field: bool is_public = 5;
         */
        this.isPublic = false;
        /**
         * @generated from field: bool for_rehearsal = 6;
         */
        this.forRehearsal = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Endpoint().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Endpoint().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Endpoint().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Endpoint, a, b);
    }
}
exports.Endpoint = Endpoint;
Endpoint.runtime = protobuf_1.proto3;
Endpoint.typeName = "spwn.stream.v1.Endpoint";
Endpoint.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_over_window_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "cookie", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 5, name: "is_public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "for_rehearsal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.stream.v1.HoldingChannel
 */
class HoldingChannel extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string channel_name = 1;
         */
        this.channelName = "";
        /**
         * @generated from field: string channel_state = 2;
         */
        this.channelState = "";
        /**
         * @generated from field: repeated spwn.stream.v1.HoldingChannel.StreamingKeyInfo streaming_key_info = 3;
         */
        this.streamingKeyInfo = [];
        /**
         * @generated from field: repeated spwn.stream.v1.Endpoint endpoints = 4;
         */
        this.endpoints = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new HoldingChannel().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HoldingChannel().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HoldingChannel().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(HoldingChannel, a, b);
    }
}
exports.HoldingChannel = HoldingChannel;
HoldingChannel.runtime = protobuf_1.proto3;
HoldingChannel.typeName = "spwn.stream.v1.HoldingChannel";
HoldingChannel.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "channel_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "streaming_key_info", kind: "message", T: HoldingChannel_StreamingKeyInfo, repeated: true },
    { no: 4, name: "endpoints", kind: "message", T: Endpoint, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.HoldingChannel.StreamingKeyInfo
 */
class HoldingChannel_StreamingKeyInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string streaming_key = 1;
         */
        this.streamingKey = "";
        /**
         * @generated from field: repeated string streaming_urls = 2;
         */
        this.streamingUrls = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new HoldingChannel_StreamingKeyInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HoldingChannel_StreamingKeyInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HoldingChannel_StreamingKeyInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(HoldingChannel_StreamingKeyInfo, a, b);
    }
}
exports.HoldingChannel_StreamingKeyInfo = HoldingChannel_StreamingKeyInfo;
HoldingChannel_StreamingKeyInfo.runtime = protobuf_1.proto3;
HoldingChannel_StreamingKeyInfo.typeName = "spwn.stream.v1.HoldingChannel.StreamingKeyInfo";
HoldingChannel_StreamingKeyInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "streaming_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "streaming_urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.MediaLiveChannel
 */
class MediaLiveChannel extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string state = 3;
         */
        this.state = "";
        /**
         * @generated from field: map<string, string> tags = 4;
         */
        this.tags = {};
        /**
         * @generated from field: repeated spwn.stream.v1.MediaLiveChannel.InputAttachment input_attachments = 5;
         */
        this.inputAttachments = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MediaLiveChannel().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MediaLiveChannel().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MediaLiveChannel().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(MediaLiveChannel, a, b);
    }
}
exports.MediaLiveChannel = MediaLiveChannel;
MediaLiveChannel.runtime = protobuf_1.proto3;
MediaLiveChannel.typeName = "spwn.stream.v1.MediaLiveChannel";
MediaLiveChannel.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tags", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 5, name: "input_attachments", kind: "message", T: MediaLiveChannel_InputAttachment, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.MediaLiveChannel.InputAttachment
 */
class MediaLiveChannel_InputAttachment extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MediaLiveChannel_InputAttachment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MediaLiveChannel_InputAttachment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MediaLiveChannel_InputAttachment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(MediaLiveChannel_InputAttachment, a, b);
    }
}
exports.MediaLiveChannel_InputAttachment = MediaLiveChannel_InputAttachment;
MediaLiveChannel_InputAttachment.runtime = protobuf_1.proto3;
MediaLiveChannel_InputAttachment.typeName = "spwn.stream.v1.MediaLiveChannel.InputAttachment";
MediaLiveChannel_InputAttachment.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=admin_common_pb.js.map